var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wPageCrumbs"},[_c('div',{ref:"wCrumbs",staticClass:"wPCrumbs-crumbs"},[_c('wCrumbs')],1),_c('div',{staticClass:"wPCrumbs-main",class:{ isShow: _vm.isShow },style:({ top: `${_vm.wPos_top}px` }),attrs:{"id":"wPCrumbsMain"}},[_c('div',{staticClass:"wPageContainer"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }